"use client";

import React, { useRef, useEffect } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

interface ProjectOutputProps {
  stats: { value: string; label: string }[];
  id?: string;
}

const ProjectOutput: React.FC<ProjectOutputProps> = ({ stats, id }) => {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.fromTo(
        ".output-item",
        { y: 24, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 0.6,
          stagger: 0.1,
          ease: "power2.out",
          scrollTrigger: {
            trigger: sectionRef.current,
            start: "top 85%",
          },
        },
      );
    }, sectionRef);

    return () => ctx.revert();
  }, []);

  return (
    <section
      ref={sectionRef}
      id={id}
      className="py-24 border-t border-[#e8e8e8]"
    >
      <div className="container mx-auto px-4">
        <div className="max-w-7xl mx-auto">
          <h2 className="output-item text-sm uppercase tracking-[0.15em] text-[#525252] font-pp-neuebit mb-16">
            Output
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-y-24 gap-x-24 lg:gap-x-40">
            {stats.map((stat, index) => (
              <div key={index} className="output-item flex flex-col gap-2">
                <span className="text-[64px] md:text-[96px] font-pp-neuebit font-bold text-[#111111] leading-[0.75]">
                  {stat.value}
                </span>
                <span className="text-[18px] md:text-[20px] text-[#404040] font-neue-regrade-variable leading-snug max-w-[164px]">
                  {stat.label}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProjectOutput;
